import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalActionsPreviousIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-actions-previous"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M15.833 10H4.167M10 4.167 4.167 10 10 15.833"
        />
    </svg>
);
const Memo = memo(ImageModalActionsPreviousIcon);
export default Memo;
